var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgVg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2e52b2",
  d: "M256 107.951v30.712h-46.069z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
  fill: "#d80027"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2e52b2",
  d: "M256 107.951v30.712h-46.069z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
  fill: "#d80027"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M384 259.706l-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z",
  fill: "#ffda44"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z",
  fill: "#6da544"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M372.87 215.181h22.261v59.359H372.87z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 384,
  cy: 215.181,
  r: 11.13,
  fill: "#a2001d"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
  fill: "#ffda44"
})));

export default SvgVg;